import { render, staticRenderFns } from "./resources-language-picker.vue?vue&type=template&id=87ef610e&"
import script from "./resources-language-picker.vue?vue&type=script&lang=ts&"
export * from "./resources-language-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports